import { API_LOCATION_URL } from 'infrastructure/config';
import {
    IGetInput,
    IGetResponse,
    ISupporterCheckTokenClient,
} from 'interfaceAdapter/gatewaySchemas/ISupporterCheckTokenClient';
import { getCookie } from 'utils/cookie';

const csrfToken = getCookie('csrftoken');

export class SupporterCheckTokenClient implements ISupporterCheckTokenClient {
    async get(input: IGetInput): Promise<IGetResponse> {
        const { token, addLoginCount } = input;
        const PATH = `${API_LOCATION_URL}/supporter/user/check_token?login_count=${addLoginCount}`;
        const method = 'GET';
        const headers: { [key: string]: string } = {
            'Content-Type': 'application/json',
            'X-HTTP-AUTH-TOKEN-S': token,
        };

        if (csrfToken) {
            headers['X-CSRFToken'] = csrfToken;
        }
        try {
            const response = await fetch(PATH, {
                method,
                headers,
            });
            return response.json();
        } catch {
            throw new Error('処理に失敗しました');
        }
    }
}
